import React from 'react'
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CautionImg from '../assets/caution_img.svg'

const InfoText = ({text, style = {}}) => {
    const theme = useTheme();
    return (
            <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", borderRadius: "4px", backgroundColor: "#FFFEE7", width: "100%", padding: "2px 8px", ...style }}>
                <img src={CautionImg} alt='Caution' width={13} height={13} />
                <Box sx={{ color: theme.palette.darkBrown.main, fontSize: "12px", fontWeight: theme.typography.fontWeightSemibold, marginLeft: "10px" }}>{text}</Box>
            </Box>
    )
}

export default InfoText